export default "__VITE_ASSET__kpLO9DZH__"